import React from 'react'
import useFetch from 'hooks/useFetch'
import Teaser from './Teaser'

export default function IPCPlacement() {
  const [loading, error, data] = useFetch('content/teaser')

  if (error || loading || !data) {
    return null
  }

  return (
    <Teaser
      header={data.header}
      body={data.body}
      ctaUrl={data.ctaUrl}
      ctaText={data.ctaText}
      img={data.img}
    />
  )
}
